export const PersonChat = ({
  fill,
  className,
}: {
  fill: string
  className: string
}) => (
  <svg
    className={className}
    fill={fill}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M10.5 14C12.9862 14 15 11.9862 15 9.5C15 7.01375 12.9862 5 10.5 5C8.01375 5 6 7.01375 6 9.5C6 11.9862 8.01375 14 10.5 14ZM10.5 16.25C7.49625 16.25 1.5 17.7575 1.5 20.75V23H19.5V20.75C19.5 17.7575 13.5037 16.25 10.5 16.25Z' />
    <g clipPath='url(#clip0_4746_22919)'>
      <path d='M22.5 1.25H16.5C16.0875 1.25 15.7537 1.5875 15.7537 2L15.75 8.75L17.25 7.25H22.5C22.9125 7.25 23.25 6.9125 23.25 6.5V2C23.25 1.5875 22.9125 1.25 22.5 1.25ZM21.75 5.75H17.25V5H21.75V5.75ZM21.75 4.625H17.25V3.875H21.75V4.625ZM21.75 3.5H17.25V2.75H21.75V3.5Z' />
    </g>
    <defs>
      <clipPath id='clip0_4746_22919'>
        <rect width='9' height='9' fill='white' transform='translate(15 0.5)' />
      </clipPath>
    </defs>
  </svg>
)
